import { Classroom } from '@teetsh/app/src/types/classroom';
import { DEFAULT_CYCLE } from 'containers/scholarSystem';

export function getCycleFromClassrooms(classrooms: Classroom[]) {
  if ((classrooms || []).length === 0) {
    return DEFAULT_CYCLE;
  }
  const cycles = classrooms[0].cycle;
  if ((cycles || []).length === 0) {
    return DEFAULT_CYCLE;
  }
  return cycles[0];
}
